import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'

import { PathNode, Task, UserTask, Resource } from '../../models'
import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

import { ResourceService, UserTaskService } from '..'
import { NoPathsError } from '../../../models'
import { AppContext } from '../../../helpers'

@Injectable()
export class PathService extends ModelRepositoryAdapter<PathNode>  {

  private static SYLLABUS_RELATIONSHIPS: string[] = ['pathNodes.pathNodes.tasks.tasks.tasks']

  constructor(
    private _modelRepository: ModelRepository,
    private _resourceService: ResourceService,
    private _userTaskService: UserTaskService,
    private _appContext: AppContext
  ) {
    super(_modelRepository, PathNode)
  }

  public getAssignedPath(includeRelations: string[] = []): Observable<PathNode> {
    const criteria = {
      nodeType: 'syllabus',
      userSyllabusAssigned: this._appContext.currentUser.id
    }
    return this.findModelsBy(criteria, includeRelations )
      .map((paths: PathNode[]) => {
        if (paths.length <= 0) {
          throw new NoPathsError()
        }
        return paths[0]
      })
  }

  public getPaths(includeRelations: string[] = []): Observable<PathNode[]> {
    return this.findModelsBy({nodeType: 'syllabus'}, includeRelations )
      .map((paths: PathNode[]) => {
        if (paths.length <= 0) {
          throw new NoPathsError()
        }
        return paths
      })
  }

  public getPath(pathId: string): Observable<PathNode> {
    return this.findModelById(pathId, PathService.SYLLABUS_RELATIONSHIPS)
      .concatMap((path) => this._preloadTaskRelationships(path))
  }

  private _preloadTaskRelationships(path: PathNode) {
    const observables: Array<Observable<void>> = [Observable.of(undefined /*noop*/)]
    path.pathNodes.forEach((unit) => {
      unit.pathNodes.forEach((section) => {
        section.tasks.forEach((task) => {
          observables.push(this._ensureTaskHasResource(task))
          observables.push(this._ensureTaskHasUserTask(task))
        })
      })
    })
    return Observable.forkJoin(...observables).map(() => path)
  }

  private _ensureTaskHasResource(task: Task): Observable<void> {
    return this._resourceService.findModelsBy({id: task.resourceId}).map((resource: Resource[]) => {
      task.resource = resource[0]
    })
  }

  private _ensureTaskHasUserTask(task: Task): Observable<void> {
    return this._userTaskService.findModelsBy({task: task}).map((userTasks: UserTask[]) => {
      task.userTask = userTasks[0]
    })
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/path/path.service.ts